<app-app-download title="SWcapture App"
                  icon="fa-camera"
                  subtitle="Photograph an order form and attach it to the Record of Sale"
                  description="SWcapture lets you snap a photo of a paper order form, or pick one from your gallery, and attach it to the matching order on your Record of Sales in seconds. It needs an internet connection to upload."
                  [iosDownloadUri]="iosAppUri"
                  [androidDownloadUri]="androidAppUri"
                  [androidInstructionsUri]="androidAppDownloadInstructionsUri"
                  [iosInstructionsUri]="iOSAppDownloadInstructionsUri"
                  [supportUri]="supportUri">

   <li>
      Enter the remittance number and the app finds the order on your Record of Sales, showing the customer name
      and order date so you can confirm it's the right one.
      <span class="text-danger fw-semibold">Note:</span> the order must already be entered on your Record of Sales;
      the remittance number has to exist on your dealer account.
   </li>
   <li>Take a photo of the order form, or pull an existing photo from your gallery.</li>
   <li>Compresses the image and uploads it to Record of Sales quickly, even on a weak connection.</li>

</app-app-download>
